import React, {useEffect, useState} from "react"
import StoreList from './StoreList';
import { translate } from '../Services/translation';
import Popup from './Popup';
import { getClickCollectOrgs } from '../Actions/GetClickCollectOrgs.action';
import { useDispatch, useSelector } from 'react-redux';
const ClickCollectContainer = ({productId, isInStock}) => {
  
  const dispatch = useDispatch();
  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const stores = useSelector((state) => state.clickCollectOrgs);
  const hasStock = (isInStock === "True")
  const [store, setStore] = useState(null);
  const [reRender, setReRender] = useState(true);

  const handleOpenPopup = (productId) => {
    setOpenStoreList(true);
    dispatch(getClickCollectOrgs(productId))
  }
  useEffect(() => {
    let preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    let clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));
    
    if(store == null && preffStore && preffStore.productAssortment?.includes("active")&& reRender){

        let streetAddress = preffStore.streetName;
        streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
        streetAddress += preffStore.city ? " " + preffStore.city : "";
  
        setStore({
          organizationId: preffStore.organizationId,
          organizationName: preffStore.companyName,
          email: preffStore.email,
          homePage: preffStore.homePage,
          address: streetAddress,
          productAssortment: preffStore.productAssortment,
          shopName: preffStore.name,
          longitude: preffStore.longitude,
          latitude: preffStore.latitude
        })
        setReRender(false)
        window.localStorage.removeItem('preferredclickcollectaddress');
      
    }
    else if(clickStore){
      setStore(clickStore);
    }

  },[isOpenStoreList])
  return (
    <div className="easyline-stock-info">
    {hasStock ? (
      <a className="product__stock-info" onClick={() => handleOpenPopup(productId)}>
        {translate('product.isinstock')} <span className="product__stock-info--textcolor">{translate('product.showstores')}</span>
      </a>
    ) : (
      <div className="product__stock-info">{translate('product.isnotinstock')}</div>
    )}
    <Popup
          isOpen={isOpenStoreList}
          setOpen={setOpenStoreList}
          component={<StoreList store={store} setStore={setStore} stores={stores.organizations} closeModal={() => setOpenStoreList(false)}></StoreList>}
        ></Popup>
        </div>)
}

export default ClickCollectContainer
